import React, { useContext, useEffect, useState } from "react";
import { NavLink, Navigate } from "react-router-dom";
import "../css/Navbar.css";
import { FaBars, FaTimes } from "react-icons/fa";
import { AuthContext } from "../pages/AuthContext";

export default function Navbar() {
  const { user, setUser, loading, setLoading } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({});

  const path = window.location.pathname;

  // Dynamisk login-type
  let loginType = "/";
  if (path.includes("/signup-academy")) loginType = "user";
  if (path.includes("/tilmelding")) loginType = "academy";

  const DISCORD_LOGIN_URL = "https://linxlegacyacademy.dk/auth/discord/login";

  // Hent bruger
  useEffect(() => {
    fetch("https://linxlegacyacademy.dk/auth/user", { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        if (data.steam_id || data.discord_id) setUser(data);
        else setUser(null);
        setLoading(false);
      })
      .catch(() => {
        setUser(null);
        setLoading(false);
      });
  }, [setUser, setLoading]);

  // Luk menu ved resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1300) setMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (loading) return null;

  // Redirect hvis bruger ikke er logget ind
  if (!user && path.includes("/profil")) return <Navigate to="/login" />;

  const logout = async () => {
    await fetch("https://linxlegacyacademy.dk/auth/logout", { credentials: "include" });
    setUser(null);
    window.location.href = "/login";
  };

  // Menu links
  const navLinks = [
    { to: "/", label: "Forside" },
    { to: "/Fornyemedlemmer", label: "For nye medlemmer" },
    { to: "/SchoolsAndClubsPage", label: "Skoler & Klub" },
    { to: "/Gametime", label: "Holdtider" },
    { to: "/Gamespage", label: "Spil vi tilbyder" },
    { to: "/Omos", label: "Om os" },
    { to: "/opening-prices", label: "Åbningstider & Priser" },
  ];

  return (
    <nav className={`academy-navbar ${menuOpen ? "open" : ""}`}>
      {/* Logo */}
      <div className="nav-left">
        <NavLink to="/" className="nav-logo-wrap">
          <div className="logo-bg"></div>
          <img src="/favicon.ico" alt="Linx Logo" className="nav-logo" />
          <span className="nav-brand">
            Linx<br />Academy
          </span>
        </NavLink>
      </div>

      {/* Desktop Links */}
      <div className="nav-center">
        {navLinks.map((link, idx) =>
          link.dropdown ? (
            <div key={idx} className="nav-item-with-dropdown">
              <button
                className="dropdown-toggle"
                onClick={() => setDropdownOpen((prev) => !prev)}
              >
                {link.label}
              </button>
              <div className={`dropdown-menu ${dropdownOpen ? "open" : ""}`}>
                {link.dropdown.map((d, i) => (
                  <NavLink key={i} to={d.to} className={({ isActive }) => isActive ? "active" : ""}>
                    {d.label}
                  </NavLink>
                ))}
              </div>
            </div>
          ) : (
            <NavLink key={idx} to={link.to} className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
              {link.label}
            </NavLink>
          )
        )}
      </div>

      {/* Desktop Right */}
      <div className="nav-right">
        {!user ? (
          <>
            <button
              className="discord-login"
              onClick={() => (window.location.href = `${DISCORD_LOGIN_URL}?type=${loginType}`)}
            >
              Login
            </button>
            <NavLink to="/signup-academy" className={({ isActive }) => isActive ? "register-link active" : "register-link"}>
              Bliv medlem
            </NavLink>
          </>
        ) : (
          <>
            <NavLink to="/profile-academy" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
              Profil
            </NavLink>
            <button onClick={logout} className="logout-btn">Log ud</button>
          </>
        )}
      </div>

      {/* Burger */}
      <button className="burger" onClick={() => setMenuOpen((prev) => !prev)}>
        {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>

      {/* Mobile Menu */}
      <div className="mobile-menu">
        {navLinks.map((link, idx) =>
          link.dropdown ? (
            <div key={idx} className="nav-item-with-dropdown">
              <button
                className="dropdown-toggle"
                onClick={() => setDropdownOpen((prev) => !prev)}
              >
                {link.label}
              </button>
              <div className={`dropdown-menu ${dropdownOpen ? "open" : ""}`}>
                {link.dropdown.map((d, i) => (
                  <NavLink key={i} to={d.to} className={({ isActive }) => isActive ? "active" : ""} onClick={() => setMenuOpen(false)}>
                    {d.label}
                  </NavLink>
                ))}
              </div>
            </div>
          ) : (
            <NavLink key={idx} to={link.to} className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} onClick={() => setMenuOpen(false)}>
              {link.label}
            </NavLink>
          )
        )}

        {/* User actions */}
        {!user ? (
          <>
            <button
              className="discord-login"
              onClick={() => (window.location.href = `${DISCORD_LOGIN_URL}?type=${loginType}`)}
            >
              Login
            </button>
            <NavLink to="/signup-academy" className="register-link" onClick={() => setMenuOpen(false)}>
              Bliv medlem
            </NavLink>
          </>
        ) : (
          <>
            <NavLink to="/profile-academy" className="nav-link" onClick={() => setMenuOpen(false)}>
              Profil
            </NavLink>
            <button onClick={logout} className="logout-btn">Log ud</button>
          </>
        )}
      </div>
    </nav>
  );
}